<div class="price-filter"
     [mmTestId]="'PRODUCT_CATALOG.PRICE_FILTERS'">

  <div class="price-range"
       fxLayout="column"
       fxFlex="100"
       fxLayoutAlign="center center">
    <div
      class="price-range__desktop-inputs"
      fxLayout="row"
      fxLayoutAlign="space-between center">

      <div class="price-range__desktop-inputs__item">
        <mm-field class="price-range__desktop-inputs__item__field">
          <input
            mmInput
            type="number"
            inputmode="numeric"
            [attr.aria-label]="'FILTERS.FILTER_TAGS.PRICE_RANGE_TAG.TEXT.MIN.LABEL' | translate"
            [value]="from"
            [min]="min"
            [max]="max"
            (change)="onFromChange($event)"
          >
        </mm-field>
      </div>

      <div class="price-range__desktop-inputs__dash"
           fxLayoutAlign="center center">
        <span>-</span>
      </div>

      <div class="price-range__desktop-inputs__item">
        <mm-field class="price-range__desktop-inputs__item__field">
          <input
            mmInput
            type="number"
            inputmode="numeric"
            [attr.aria-label]="'FILTERS.FILTER_TAGS.PRICE_RANGE_TAG.TEXT.MAX.LABEL' | translate"
            [value]="to"
            [min]="min"
            [max]="max"
            (change)="onToChange($event)">
        </mm-field>
      </div>

    </div>
    <ngx-slider
      *ngIf="min != null && max != null"
      class="price-range__slider"
      [(value)]="from"
      [(highValue)]="to"
      [options]="options"
      (userChangeEnd)="onUserChangeEnd($event)"
    ></ngx-slider>

  </div>
</div>
